import { render, staticRenderFns } from "./TaskChangeAuthor.vue?vue&type=template&id=6a0e9c2e&scoped=true&lang=pug&"
import script from "./TaskChangeAuthor.vue?vue&type=script&lang=js&"
export * from "./TaskChangeAuthor.vue?vue&type=script&lang=js&"
import style0 from "./TaskChangeAuthor.vue?vue&type=style&index=0&id=6a0e9c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0e9c2e",
  null
  
)

export default component.exports